import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

function ModalBase({ isOpen, toggle, header, body, footer, className = '' }) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      className={`modal-base modal-dialog-centered ${className}`}
    >
      {/* HEADER */}
      <ModalHeader className="modal-base-header" toggle={toggle}>
        {header}
      </ModalHeader>

      {/* BODY */}
      <ModalBody className="modal-base-body">{body}</ModalBody>

      {/* FOOTER ,optional */}
      {footer && (
        <ModalFooter className="modal-base-footer">{footer}</ModalFooter>
      )}
    </Modal>
  );
}

export default ModalBase;
